export const IOS_APP_STORE_URL =
  "https://apps.apple.com/us/app/gondola-ai/id6751292391";
export const ANDROID_APP_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.gondola.ai";

export type MobileOS = "ios" | "android";

// Android is matched explicitly; everything else (iOS and desktop) falls back
// to the App Store link, matching the existing download-CTA pattern elsewhere
// in the app (see JobCards.tsx, WebviewDownloadApp.tsx).
export function detectMobileOS(userAgent: string): MobileOS {
  return /android/i.test(userAgent) ? "android" : "ios";
}

export function getAppStoreUrl(os: MobileOS): string {
  return os === "android" ? ANDROID_APP_STORE_URL : IOS_APP_STORE_URL;
}
